import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dragosWorldview = defineConnector({
  identifier: "dragosWorldview",
  name: "Dragos Worldview",
  tagLine: "ICS/OT threat intelligence",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://portal\\.dragos\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Api-Token", value: app.secret.apiToken },
      { name: "Api-Secret", value: app.secret.apiSecret },
    ]),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log into the [Dragos Portal](https://portal.dragos.com). Navigate to your account settings and generate API credentials.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
          helperText: "Your Dragos API token.",
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
          helperText: "Your Dragos API secret.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://portal.dragos.com/api/v1/products",
  },
});
